import React, { useState, useEffect, useContext } from 'react';



import { FcViewDetails } from "react-icons/fc";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalInFormatter, totalOutFormatter } from '../../components/formatters/numberFormatter';
import { typeFormatter, paymentTypeFormatter, statusFormatter } from '../../components/formatters/defFormatter';
import { createdHourFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Tabs, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';
import { PosCartContext } from '../../init/posCartData';
import PosForm from '../pos/posForm';


function DineIn(props) {

  let { type, isDebit, isOrder } = props;

  const { api, userData, settingData, refProductData, devData, companyId, yearId, refData } = useContext(DataContext);
  const { tabData, setCart } = useContext(PosCartContext);

  const userRole = userData.role;
  const createdBy = parseInt(userData.id);
  const roundTo = settingData.roundTo;

  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [tableNumber, setTableNumber] = useState(1);

  const [tableData, setTableData] = useState([]);


  const [editedJv, setEditedJv] = useState(false);

  const numberOfTables = settingData.numberOfTables;
  const columnsPerRow = 6;

  const numberOfTabs = settingData.numberOfTabs;
  const editJvTabNumber = numberOfTabs + 1;

  const tableGrid = Array.from({ length: numberOfTables }, (_, i) => i + 1);

  useEffect(() => {
    refFetchData();
    getTablesData();
  }, []);

  const refFetchData = async () => {
    try {
      setIsLoading(true);
      const dataArray = ['category', 'salable', 'customerAccount', 'currency', 'delivery', 'posDetails']
      if (settingData.useCustomerPrice) {
        dataArray.push('customerPrice')
      }
      await refData(dataArray, companyId, yearId);
      setIsLoading(false);
    } catch (error) {
      console.error('Error refreshing data Contact Support');
    }
  };


  const getTablesData = async () => {
    const data = {
      filter: {
        type: ['TableOrder'],
        companyId,
        yearId,
      }
    }
    await api.get(`/journalVoucher/getall`, { params: data }).then(response => {
      if (!response.data.status) {
        toast.error(response.data.message)
      } else {
        setTableData(response.data.data);
      }
    })

  }


  const getTableCart = async (tableId) => {

    const data = {
      filter: {
        type: ['TableOrder'],
        companyId,
        yearId,
        tableId,
      }
    }
    await api.get(`/journalVoucher/getall`, { params: data }).then(response => {
      if (!response.data.status) {
        toast.error(response.data.message)
      } else {
        setEditedJv(response.data.data[0]);
      }
    })

  }

  const openModal = async (tableId) => {
    const editJv = tableData?.find(item => item.tableId === tableId);
    if (!showModal) {
      setTableNumber(tableId);
      await getTableCart(tableId);
    } else {
      setCart([], editJvTabNumber);
    }
    setShowModal(!showModal);
  }



  const editModal = (e) => {
    if (!showModal && e) {
      setEditedJv(e);
    }
    else {
      setEditedJv(null);
    }
    setShowModal(!showModal);
  }

  return (
    <>

      {isLoading && <Loader />}

      {!isLoading &&
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24, width: '90%' }}>


          {Array.from({ length: Math.ceil(numberOfTables / columnsPerRow) }, (_, rowIndex) => {
            const rowTables = tableGrid.slice(
              rowIndex * columnsPerRow,
              (rowIndex + 1) * columnsPerRow
            );
            const emptyCols = columnsPerRow - rowTables.length;

            return (
              <Row key={rowIndex} gutter={[24, 24]}>
                {rowTables.map((tableId) => (
                  <Col key={tableId} span={4}>
                    <div
                      style={{
                        width: '65%',
                        paddingTop: '60%',
                        backgroundColor: tableData?.find(item => item.tableId === tableId) ? '#a5c437' : '#eee',
                        border: '1px solid #ccc',
                        position: 'relative',
                        textAlign: 'center',
                        cursor: 'pointer',
                      }}
                      onClick={() => openModal(tableId)}
                    >
                      <div
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <h4>{tableId} {tabData[tableId]?.totalCredit}</h4>
                      </div>
                    </div>
                  </Col>
                ))}
                {/* Fill the rest of the row with empty cols to keep spacing */}
                {Array.from({ length: emptyCols }).map((_, idx) => (
                  <Col key={`empty-${idx}`} span={4} />
                ))}
              </Row>
            );
          })}
        </div>
      }


      {showModal &&
        <PosForm
          showModal={showModal}
          toggleModal={openModal}
          refFetchData={refFetchData}
          tableNumber={tableNumber}
          tableMode={true}
          editedJv={editedJv}
        />
      }


    </>
  );
}

export default DineIn;
